import { useState } from 'react';

// cache the entity event time if it does not exist
// if it does exist - compare this time with the incoming event time
// if the incoming event time is older than the last event for a given entity - IE less than the current latest
// time - we want to ignore this event to avoid confusing behavior in the ui
const useIsOutOfOrderEvent = () => {
  const [lastEventTimeCache, setLastEventTimeCache] = useState<
    Record<string, string>
  >({});
  return (entityId: string, eventTime: string) => {
    const latestTime = lastEventTimeCache[entityId];
    const incomingTime = eventTime;
    const outOfOrderEvent = latestTime && incomingTime < latestTime;
    if (outOfOrderEvent) {
      return true;
    }
    setLastEventTimeCache({
      ...lastEventTimeCache,
      [entityId]: incomingTime,
    });
  };
};

export default useIsOutOfOrderEvent;
